var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accountInformationWrap"},[(_vm.showCom ==='Account')?_c('AccountShow'):_vm._e(),(_vm.showCom ==='editPhone')?_c('EditPhone'):_vm._e(),(_vm.showCom ==='editPassword')?_c('EditPassword'):_vm._e(),(_vm.showCom ==='resetPassword')?_c('ResetPasswordForm'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }